var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandarddisedProjectImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41058",
    "data-name": "Group 41058",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 468.208,
    height: 455.803,
    viewBox: "0 0 468.208 455.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-6, .cls-8, .cls-9 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #4eb2a2;\r\n      }\r\n\r\n      .cls-4 {\r\n        opacity: 0.7;\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-6, .cls-8, .cls-9 {\r\n        stroke: #012d35;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #012d35;\r\n      }\r\n\r\n      .cls-8 {\r\n        stroke-width: 6px;\r\n      }\r\n\r\n      .cls-9 {\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #a6a6a6;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7915",
    "data-name": "Rectangle 7915",
    className: "cls-1",
    width: 468.208,
    height: 455.803
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41057",
    "data-name": "Group 41057",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41056",
    "data-name": "Group 41056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41055",
    "data-name": "Group 41055",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40909",
    "data-name": "Path 40909",
    className: "cls-3",
    d: "M467.886,207.426c-3.05-59.89-28.03-119.62-73.05-160.01-70.79-63.5-208.68-62.14-281.33-2.4-25.2,20.72-40.03,48.1-45.83,79.86-6.2,33.99,1.91,70.92-11.43,103.66-11.46,28.11-39.71,45.35-50.18,73.79-12.5,33.96-5.82,77.1,21.32,102.34,34.76,32.33,96.8,44.79,142.51,49.5,139.61,14.39,286.81-66.71,297.72-218.28a232.662,232.662,0,0,0,.29-28.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41054",
    "data-name": "Group 41054",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41053",
    "data-name": "Group 41053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41052",
    "data-name": "Group 41052",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40910",
    "data-name": "Path 40910",
    className: "cls-5",
    d: "M467.886,207.426c-3.05-59.89-28.03-119.62-73.05-160.01-70.79-63.5-208.68-62.14-281.33-2.4-25.2,20.72-40.03,48.1-45.83,79.86-6.2,33.99,1.91,70.92-11.43,103.66-11.46,28.11-39.71,45.35-50.18,73.79-12.5,33.96-5.82,77.1,21.32,102.34,34.76,32.33,96.8,44.79,142.51,49.5,139.61,14.39,286.81-66.71,297.72-218.28a232.662,232.662,0,0,0,.29-28.44Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40911",
    "data-name": "Path 40911",
    className: "cls-6",
    d: "M18.426,175.756c-1.56,2.48-2.94,4.79-2.94,4.79s-3.21,5.97-4.59,9.19l-1.38,3.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40912",
    "data-name": "Path 40912",
    className: "cls-6",
    d: "M438.806,194.316h-176.7s-27.56-6.89-34.9-9.19-17.45-1.84-21.13-.92-14.24,1.84-14.24,1.84l-14.7-6.89-5.97-5.05-9.64-10.56-8.27-12.86-8.27-5.51-11.48-4.59-29.39-13.78H68.756l-13.32.46-10.56,9.64-19.29,11.94s-1.84,19.75-3.21,21.13"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_185",
    "data-name": "Line 185",
    className: "cls-6",
    x1: 10.44,
    transform: "translate(447.306 194.316)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_186",
    "data-name": "Line 186",
    className: "cls-6",
    x2: 354.24,
    transform: "translate(98.616 433.146)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_187",
    "data-name": "Line 187",
    className: "cls-6",
    x2: 53.51,
    transform: "translate(34.056 433.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40913",
    "data-name": "Path 40913",
    className: "cls-7",
    d: "M307.2,150.5s3.95-32.03-11.85-43.87-82.04-58.79-82.04-58.79l-12.03-12.91a2.723,2.723,0,0,1,2.79-3.5l18.02,6.32s78.53,38.17,89.06,46.94,15.36,25.45,16.23,35.98.88,31.15.88,31.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40914",
    "data-name": "Path 40914",
    className: "cls-6",
    d: "M307.2,150.5s3.95-32.03-11.85-43.87-82.04-58.79-82.04-58.79l-12.03-12.91a2.723,2.723,0,0,1,2.79-3.5l18.02,6.32s78.53,38.17,89.06,46.94,15.36,25.45,16.23,35.98.88,31.15.88,31.15Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_188",
    "data-name": "Line 188",
    className: "cls-8",
    y1: 30.67,
    x2: 42.41,
    transform: "translate(141.946 20.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40915",
    "data-name": "Path 40915",
    className: "cls-7",
    d: "M135.5,64.966,105.446,66a3.632,3.632,0,0,0-3.51,3.63,3.589,3.589,0,0,0,3.23,3.61l2.76,19.56a3.62,3.62,0,0,0,2.88,6.29l13.29-1.26a2.245,2.245,0,0,0-.36-4.47l-9.17-1.02-4.56-19.61,25.84-3.28a2.245,2.245,0,0,0-.36-4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40916",
    "data-name": "Path 40916",
    className: "cls-6",
    d: "M135.5,64.966,105.446,66a3.632,3.632,0,0,0-3.51,3.63,3.589,3.589,0,0,0,3.23,3.61l2.76,19.56a3.62,3.62,0,0,0,2.88,6.29l13.29-1.26a2.245,2.245,0,0,0-.36-4.47l-9.17-1.02-4.56-19.61,25.84-3.28a2.245,2.245,0,0,0-.36-4.47Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_189",
    "data-name": "Line 189",
    className: "cls-9",
    y1: 21.1,
    x2: 28.67,
    transform: "translate(113.276 50.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40917",
    "data-name": "Path 40917",
    className: "cls-5",
    d: "M198.826,11.856l-18.86,7.46,3.95,5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40918",
    "data-name": "Path 40918",
    className: "cls-6",
    d: "M198.826,11.856l-18.86,7.46,3.95,5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40919",
    "data-name": "Path 40919",
    className: "cls-7",
    d: "M179.676,83.216l-7.66,1.44-11.25-.72-2.36,2.36-23.02-8.58h-16.04a10.976,10.976,0,0,0-3.35,5.03c-.72,2.87.96,6.46,1.92,11.97s-1.2,11.01.48,16.52a16.731,16.731,0,0,0,14.1,11.94l.02.03h.2a20.776,20.776,0,0,0,4.1,0h12.7v-3.59h-1.58c11.69-6.84,18.74-21.61,19.77-23.46l2.39.24,25.62-13.17h-16.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40920",
    "data-name": "Path 40920",
    className: "cls-6",
    d: "M179.676,83.216l-7.66,1.44-11.25-.72-2.36,2.36-23.02-8.58h-16.04a10.976,10.976,0,0,0-3.35,5.03c-.72,2.87.96,6.46,1.92,11.97s-1.2,11.01.48,16.52a16.731,16.731,0,0,0,14.1,11.94l.02.03h.2a20.776,20.776,0,0,0,4.1,0h12.7v-3.59h-1.58c11.69-6.84,18.74-21.61,19.77-23.46l2.39.24,25.62-13.17h-16.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40921",
    "data-name": "Path 40921",
    className: "cls-3",
    d: "M115.616,84.936l99.89-47.63,6.87-20.6a2.535,2.535,0,0,0-2.22-3.33l-21.31-1.52L112.4,79.546a3.169,3.169,0,0,0,3.21,5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40922",
    "data-name": "Path 40922",
    className: "cls-6",
    d: "M115.616,84.936l99.89-47.63,6.87-20.6a2.535,2.535,0,0,0-2.22-3.33l-21.31-1.52L112.4,79.546a3.169,3.169,0,0,0,3.21,5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40923",
    "data-name": "Path 40923",
    className: "cls-3",
    d: "M223.4,16.246a3.51,3.51,0,1,0-3.51,3.51,3.508,3.508,0,0,0,3.51-3.51"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1270",
    "data-name": "Ellipse 1270",
    className: "cls-6",
    cx: 3.51,
    cy: 3.51,
    r: 3.51,
    transform: "translate(216.376 12.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40924",
    "data-name": "Path 40924",
    className: "cls-3",
    d: "M108.786,69.776l3.66,25.95h7.02l-6.1-26.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40925",
    "data-name": "Path 40925",
    className: "cls-6",
    d: "M108.786,69.776l3.66,25.95h7.02l-6.1-26.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40926",
    "data-name": "Path 40926",
    className: "cls-3",
    d: "M139.6,64.966,109.546,66a3.631,3.631,0,1,0,.58,7.23l29.83-3.79a2.245,2.245,0,0,0-.36-4.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40927",
    "data-name": "Path 40927",
    className: "cls-6",
    d: "M139.6,64.966,109.546,66a3.631,3.631,0,1,0,.58,7.23l29.83-3.79a2.245,2.245,0,0,0-.36-4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40928",
    "data-name": "Path 40928",
    className: "cls-3",
    d: "M127.846,93.346l-13.52-1.51a3.631,3.631,0,1,0,.58,7.23l13.29-1.26a2.245,2.245,0,0,0-.36-4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40929",
    "data-name": "Path 40929",
    className: "cls-6",
    d: "M127.846,93.346l-13.52-1.51a3.631,3.631,0,1,0,.58,7.23l13.29-1.26a2.245,2.245,0,0,0-.36-4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40930",
    "data-name": "Path 40930",
    className: "cls-3",
    d: "M115.036,96.856l12.7-19.25a3.632,3.632,0,1,0-5.8-4.36l-10.48,20.92a2.244,2.244,0,0,0,3.58,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40931",
    "data-name": "Path 40931",
    className: "cls-6",
    d: "M115.036,96.856l12.7-19.25a3.632,3.632,0,1,0-5.8-4.36l-10.48,20.92a2.244,2.244,0,0,0,3.58,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40932",
    "data-name": "Path 40932",
    className: "cls-3",
    d: "M135.386,77.706a10.976,10.976,0,0,0-3.35,5.03c-.72,2.87.96,6.46,1.92,11.97s-1.2,11.01.48,16.52,8.14,15.32,23.46,11.01,24.66-23.94,25.85-26.09l2.39.24,9.58-13.17-7.66,1.44-11.25-.72-4.31,4.31-37.11-10.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40933",
    "data-name": "Path 40933",
    className: "cls-6",
    d: "M135.386,77.706a10.976,10.976,0,0,0-3.35,5.03c-.72,2.87.96,6.46,1.92,11.97s-1.2,11.01.48,16.52,8.14,15.32,23.46,11.01,24.66-23.94,25.85-26.09l2.39.24,9.58-13.17-7.66,1.44-11.25-.72-4.31,4.31-37.11-10.53Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_190",
    "data-name": "Line 190",
    className: "cls-8",
    x2: 47.03,
    y2: 39.39,
    transform: "translate(240.426 33.446)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_191",
    "data-name": "Line 191",
    className: "cls-9",
    x2: 20.54,
    y2: 17.2,
    transform: "translate(219.886 16.246)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_192",
    "data-name": "Line 192",
    className: "cls-8",
    x2: 3.29,
    y2: 44.25,
    transform: "translate(301.096 114.796)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_193",
    "data-name": "Line 193",
    className: "cls-9",
    x2: 2.35,
    y2: 26.69,
    transform: "translate(298.746 88.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40934",
    "data-name": "Path 40934",
    className: "cls-3",
    d: "M313.336,150.5s3.95-32.03-11.85-43.87-82.04-58.79-82.04-58.79l-12.03-12.91a2.723,2.723,0,0,1,2.79-3.5l18.02,6.32s78.53,38.17,89.06,46.94,15.36,25.45,16.23,35.98.88,31.15.88,31.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40935",
    "data-name": "Path 40935",
    className: "cls-6",
    d: "M313.336,150.5s3.95-32.03-11.85-43.87-82.04-58.79-82.04-58.79l-12.03-12.91a2.723,2.723,0,0,1,2.79-3.5l18.02,6.32s78.53,38.17,89.06,46.94,15.36,25.45,16.23,35.98.88,31.15.88,31.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40936",
    "data-name": "Path 40936",
    className: "cls-5",
    d: "M310.8,130.356a1.553,1.553,0,0,1-1.3-1.41l-3.36-42.18a1.55,1.55,0,0,1,3.09-.25l3.36,42.18a1.554,1.554,0,0,1-1.42,1.67,2.135,2.135,0,0,1-.36-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40937",
    "data-name": "Path 40937",
    className: "cls-6",
    d: "M310.8,130.356a1.553,1.553,0,0,1-1.3-1.41l-3.36-42.18a1.55,1.55,0,0,1,3.09-.25l3.36,42.18a1.554,1.554,0,0,1-1.42,1.67,2.135,2.135,0,0,1-.36-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40938",
    "data-name": "Path 40938",
    className: "cls-7",
    d: "M309.976,87.346a2.379,2.379,0,1,0-2.72,1.98,2.377,2.377,0,0,0,2.72-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40939",
    "data-name": "Path 40939",
    className: "cls-6",
    d: "M309.976,87.346a2.379,2.379,0,1,0-2.72,1.98A2.377,2.377,0,0,0,309.976,87.346Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7884",
    "data-name": "Rectangle 7884",
    className: "cls-7",
    width: 50.85,
    height: 5.57,
    transform: "translate(310.056 162.276)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7885",
    "data-name": "Rectangle 7885",
    className: "cls-6",
    width: 50.85,
    height: 5.57,
    transform: "translate(310.056 162.276)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7886",
    "data-name": "Rectangle 7886",
    className: "cls-7",
    width: 23.68,
    height: 24.73,
    transform: "translate(358.076 169.596)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7887",
    "data-name": "Rectangle 7887",
    className: "cls-6",
    width: 23.68,
    height: 24.73,
    transform: "translate(358.076 169.596)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7888",
    "data-name": "Rectangle 7888",
    className: "cls-7",
    width: 45.12,
    height: 4.52,
    transform: "translate(312.926 167.686)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7889",
    "data-name": "Rectangle 7889",
    className: "cls-6",
    width: 45.12,
    height: 4.52,
    transform: "translate(312.926 167.686)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7890",
    "data-name": "Rectangle 7890",
    className: "cls-7",
    width: 33.11,
    height: 5.96,
    transform: "translate(318.926 171.136)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7891",
    "data-name": "Rectangle 7891",
    className: "cls-6",
    width: 33.11,
    height: 5.96,
    transform: "translate(318.926 171.136)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7892",
    "data-name": "Rectangle 7892",
    className: "cls-7",
    width: 65.91,
    height: 5.8,
    transform: "translate(302.526 176.796)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7893",
    "data-name": "Rectangle 7893",
    className: "cls-6",
    width: 65.91,
    height: 5.8,
    transform: "translate(302.526 176.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40940",
    "data-name": "Path 40940",
    className: "cls-7",
    d: "M374.836,128.5a5.92,5.92,0,1,1-5.92-5.92,5.919,5.919,0,0,1,5.92,5.92"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1271",
    "data-name": "Ellipse 1271",
    className: "cls-6",
    cx: 5.92,
    cy: 5.92,
    r: 5.92,
    transform: "translate(362.996 122.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40941",
    "data-name": "Path 40941",
    className: "cls-7",
    d: "M406.876,135.816l-2.94-5.43a5.6,5.6,0,0,0-4.91-2.93h-23.84l-7.66,8.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40942",
    "data-name": "Path 40942",
    className: "cls-6",
    d: "M406.876,135.816l-2.94-5.43a5.6,5.6,0,0,0-4.91-2.93h-23.84l-7.66,8.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40943",
    "data-name": "Path 40943",
    className: "cls-3",
    d: "M319.116,133.376h88.41a4.934,4.934,0,0,1,4.93,4.93v25.37h-93.33v-30.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40944",
    "data-name": "Path 40944",
    className: "cls-6",
    d: "M319.116,133.376h88.41a4.934,4.934,0,0,1,4.93,4.93v25.37h-93.33v-30.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40945",
    "data-name": "Path 40945",
    className: "cls-7",
    d: "M340.666,110.716h-34.73c-2.42,10.05-4.11,23.55-5.2,42.88l-.28,5.45h18.68v-12.11c3.77-2.63,7.8-4.81,11.37-5.36,10.56-1.62,13-7.72,13-7.72l-2.84-23.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40946",
    "data-name": "Path 40946",
    className: "cls-6",
    d: "M340.666,110.716h-34.73c-2.42,10.05-4.11,23.55-5.2,42.88l-.28,5.45h18.68v-12.11c3.77-2.63,7.8-4.81,11.37-5.36,10.56-1.62,13-7.72,13-7.72l-2.84-23.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40947",
    "data-name": "Path 40947",
    className: "cls-7",
    d: "M319.336,110.716c-2.64,10.97-4.42,26.03-5.48,48.33h7.89s5.34-8.22,22.16-12.21a25.894,25.894,0,0,0,15.22-10.23l-5.07-25.89h-34.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40948",
    "data-name": "Path 40948",
    className: "cls-6",
    d: "M319.336,110.716c-2.64,10.97-4.42,26.03-5.48,48.33h7.89s5.34-8.22,22.16-12.21a25.894,25.894,0,0,0,15.22-10.23l-5.07-25.89h-34.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40949",
    "data-name": "Path 40949",
    className: "cls-5",
    d: "M303.536,144.636h8.48s1.63-20.19,4.4-30.78h-8.8S304.156,131.446,303.536,144.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40950",
    "data-name": "Path 40950",
    className: "cls-6",
    d: "M303.536,144.636h8.48s1.63-20.19,4.4-30.78h-8.8S304.156,131.446,303.536,144.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40951",
    "data-name": "Path 40951",
    className: "cls-5",
    d: "M342.116,138.986l-2.7-25.13h-18.56c-.74,4.39-2.81,17.02-3.36,25.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40952",
    "data-name": "Path 40952",
    className: "cls-6",
    d: "M342.116,138.986l-2.7-25.13h-18.56c-.74,4.39-2.81,17.02-3.36,25.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40953",
    "data-name": "Path 40953",
    className: "cls-5",
    d: "M353.356,138.986l-3.02-25.13h-6.91l2.72,25.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40954",
    "data-name": "Path 40954",
    className: "cls-6",
    d: "M353.356,138.986l-3.02-25.13h-6.91l2.72,25.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7894",
    "data-name": "Rectangle 7894",
    className: "cls-3",
    width: 9.05,
    height: 13.93,
    transform: "translate(290.906 149.746)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7895",
    "data-name": "Rectangle 7895",
    className: "cls-6",
    width: 9.05,
    height: 13.93,
    transform: "translate(290.906 149.746)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7896",
    "data-name": "Rectangle 7896",
    className: "cls-3",
    width: 111.99,
    height: 4.62,
    transform: "translate(300.456 159.046)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7897",
    "data-name": "Rectangle 7897",
    className: "cls-6",
    width: 111.99,
    height: 4.62,
    transform: "translate(300.456 159.046)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7898",
    "data-name": "Rectangle 7898",
    className: "cls-3",
    width: 13.78,
    height: 4.62,
    transform: "translate(300.456 159.046)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7899",
    "data-name": "Rectangle 7899",
    className: "cls-6",
    width: 13.78,
    height: 4.62,
    transform: "translate(300.456 159.046)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_194",
    "data-name": "Line 194",
    className: "cls-6",
    y2: 18.11,
    transform: "translate(360.206 139.986)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_195",
    "data-name": "Line 195",
    className: "cls-6",
    y2: 22.63,
    transform: "translate(379.016 135.816)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_196",
    "data-name": "Line 196",
    className: "cls-6",
    y2: 22.98,
    transform: "translate(406.876 135.816)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_197",
    "data-name": "Line 197",
    className: "cls-6",
    x2: 31.7,
    transform: "translate(379.706 146.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40955",
    "data-name": "Path 40955",
    className: "cls-10",
    d: "M283.166,169.6h21.67v24.73h-21.67a2.01,2.01,0,0,1-2.01-2.01v-20.7a2.01,2.01,0,0,1,2.01-2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40956",
    "data-name": "Path 40956",
    className: "cls-6",
    d: "M283.166,169.6h21.67v24.73h-21.67a2.01,2.01,0,0,1-2.01-2.01v-20.7a2.01,2.01,0,0,1,2.01-2.01Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_198",
    "data-name": "Line 198",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(281.256 174.116)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_199",
    "data-name": "Line 199",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(281.256 178.546)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_200",
    "data-name": "Line 200",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(281.256 182.966)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_201",
    "data-name": "Line 201",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(281.256 187.396)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_202",
    "data-name": "Line 202",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(281.256 190.656)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_203",
    "data-name": "Line 203",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(281.256 192.756)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_204",
    "data-name": "Line 204",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(281.256 171.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40957",
    "data-name": "Path 40957",
    className: "cls-10",
    d: "M366.366,169.6h20.98a2.7,2.7,0,0,1,2.7,2.7v19.37a2.659,2.659,0,0,1-2.66,2.66h-21.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40958",
    "data-name": "Path 40958",
    className: "cls-6",
    d: "M366.366,169.6h20.98a2.7,2.7,0,0,1,2.7,2.7v19.37a2.659,2.659,0,0,1-2.66,2.66h-21.02Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_205",
    "data-name": "Line 205",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(366.466 174.116)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_206",
    "data-name": "Line 206",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(366.466 178.546)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_207",
    "data-name": "Line 207",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(366.466 182.966)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_208",
    "data-name": "Line 208",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(366.466 187.396)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_209",
    "data-name": "Line 209",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(366.466 190.656)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_210",
    "data-name": "Line 210",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(366.466 192.756)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_211",
    "data-name": "Line 211",
    className: "cls-6",
    x2: 23.32,
    transform: "translate(366.466 171.556)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_212",
    "data-name": "Line 212",
    className: "cls-6",
    x2: 19.78,
    transform: "translate(382.266 137.226)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_213",
    "data-name": "Line 213",
    className: "cls-6",
    x2: 19.78,
    transform: "translate(382.266 139.206)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_214",
    "data-name": "Line 214",
    className: "cls-6",
    x2: 19.78,
    transform: "translate(382.266 141.186)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_215",
    "data-name": "Line 215",
    className: "cls-6",
    x2: 19.78,
    transform: "translate(382.266 143.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40959",
    "data-name": "Path 40959",
    className: "cls-7",
    d: "M91.016,378.306l6.64,10.51h137.77l13.28-5.53h29.32s8.3,12.17,32.64,10.51V368.9H86.036Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40960",
    "data-name": "Path 40960",
    className: "cls-6",
    d: "M91.016,378.306l6.64,10.51h137.77l13.28-5.53h29.32s8.3,12.17,32.64,10.51V368.9H86.036Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7900",
    "data-name": "Rectangle 7900",
    className: "cls-7",
    width: 283.09,
    height: 53.21,
    transform: "translate(80.246 322.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7901",
    "data-name": "Rectangle 7901",
    className: "cls-6",
    width: 283.09,
    height: 53.21,
    transform: "translate(80.246 322.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7902",
    "data-name": "Rectangle 7902",
    className: "cls-3",
    width: 48.81,
    height: 42.47,
    transform: "translate(241.396 333.626)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7903",
    "data-name": "Rectangle 7903",
    className: "cls-6",
    width: 48.81,
    height: 42.47,
    transform: "translate(241.396 333.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40961",
    "data-name": "Path 40961",
    className: "cls-3",
    d: "M124.736,298.726l-68.61,12.32v64.88h24.12v-32h117.92v-38.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40962",
    "data-name": "Path 40962",
    className: "cls-6",
    d: "M124.736,298.726l-68.61,12.32v64.88h24.12v-32h117.92v-38.77Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_216",
    "data-name": "Line 216",
    className: "cls-6",
    x2: 24.28,
    transform: "translate(56.176 363.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40963",
    "data-name": "Path 40963",
    className: "cls-6",
    d: "M80.246,343.926V330.6h36.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40964",
    "data-name": "Path 40964",
    className: "cls-3",
    d: "M127.146,237.2l4.68,47.1-10.66,10.04v29.7h78.86V284.3h.12V237.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40965",
    "data-name": "Path 40965",
    className: "cls-6",
    d: "M127.146,237.2l4.68,47.1-10.66,10.04v29.7h78.86V284.3h.12V237.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40966",
    "data-name": "Path 40966",
    className: "cls-5",
    d: "M153.436,278.266h-19.6l-3.47-34.37h23.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40967",
    "data-name": "Path 40967",
    className: "cls-6",
    d: "M153.436,278.266h-19.6l-3.47-34.37h23.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7904",
    "data-name": "Rectangle 7904",
    className: "cls-3",
    width: 38.52,
    height: 58.45,
    transform: "translate(156.616 243.896)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7905",
    "data-name": "Rectangle 7905",
    className: "cls-6",
    width: 38.52,
    height: 58.45,
    transform: "translate(156.616 243.896)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7906",
    "data-name": "Rectangle 7906",
    className: "cls-5",
    width: 33.18,
    height: 30.99,
    transform: "translate(159.286 247.576)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7907",
    "data-name": "Rectangle 7907",
    className: "cls-6",
    width: 33.18,
    height: 30.99,
    transform: "translate(159.286 247.576)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7908",
    "data-name": "Rectangle 7908",
    className: "cls-3",
    width: 2.47,
    height: 17.89,
    transform: "translate(115.526 326.086)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7909",
    "data-name": "Rectangle 7909",
    className: "cls-6",
    width: 2.47,
    height: 17.89,
    transform: "translate(115.526 326.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40968",
    "data-name": "Path 40968",
    className: "cls-3",
    d: "M145.376,280.466h-29.51v43.58h2.37v-20.47h8.32v21.51h2.37v-21.51h23.15v20.29h2.37v-35.4l-9.05-7.99Zm-27.14,2.44h8.32v18.23h-8.32Zm10.68,18.23v-18.23h15.59l7.56,6.68v11.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40969",
    "data-name": "Path 40969",
    className: "cls-6",
    d: "M145.376,280.466h-29.51v43.58h2.37v-20.47h8.32v21.51h2.37v-21.51h23.15v20.29h2.37v-35.4l-9.05-7.99Zm-27.14,2.44h8.32v18.23h-8.32Zm10.68,18.23v-18.23h15.59l7.56,6.68v11.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40970",
    "data-name": "Path 40970",
    className: "cls-3",
    d: "M212.356,335.956h2.18l-10.08-13.24h-88.93v6.39h88.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40971",
    "data-name": "Path 40971",
    className: "cls-6",
    d: "M212.356,335.956h2.18l-10.08-13.24h-88.93v6.39h88.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7910",
    "data-name": "Rectangle 7910",
    className: "cls-3",
    width: 34.55,
    height: 10.49,
    transform: "translate(50.436 374.816)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7911",
    "data-name": "Rectangle 7911",
    className: "cls-6",
    width: 34.55,
    height: 10.49,
    transform: "translate(50.436 374.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40972",
    "data-name": "Path 40972",
    className: "cls-3",
    d: "M437.276,231.866H212.9v-9l-55.91-17.98-30.89-.54v21.58h-4.72v6.48h4.72s76.56,2.29,74.05,4.8l4.31,85.51h158.88l92.58-48.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40973",
    "data-name": "Path 40973",
    className: "cls-6",
    d: "M437.276,231.866H212.9v-9l-55.91-17.98-30.89-.54v21.58h-4.72v6.48h4.72s76.56,2.29,74.05,4.8l4.31,85.51h158.88l92.58-48.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40974",
    "data-name": "Path 40974",
    className: "cls-7",
    d: "M254.416,259.166l14.68,57.86h16.72l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40975",
    "data-name": "Path 40975",
    className: "cls-6",
    d: "M254.416,259.166l14.68,57.86h16.72l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40976",
    "data-name": "Path 40976",
    className: "cls-7",
    d: "M442.316,275.486l-4.02-16.32h-16.71l5.95,23.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40977",
    "data-name": "Path 40977",
    className: "cls-6",
    d: "M442.316,275.486l-4.02-16.32h-16.71l5.95,23.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40978",
    "data-name": "Path 40978",
    className: "cls-7",
    d: "M412.736,290.7l-7.87-31.53h-16.72l9.81,39.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40979",
    "data-name": "Path 40979",
    className: "cls-6",
    d: "M412.736,290.7l-7.87-31.53h-16.72l9.81,39.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40980",
    "data-name": "Path 40980",
    className: "cls-7",
    d: "M220.986,259.166l14.68,57.86h16.72l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40981",
    "data-name": "Path 40981",
    className: "cls-6",
    d: "M220.986,259.166l14.68,57.86h16.72l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40982",
    "data-name": "Path 40982",
    className: "cls-7",
    d: "M383.116,306.056l-11.68-46.89h-16.72l13.63,54.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40983",
    "data-name": "Path 40983",
    className: "cls-6",
    d: "M383.116,306.056l-11.68-46.89h-16.72l13.63,54.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40984",
    "data-name": "Path 40984",
    className: "cls-7",
    d: "M287.856,259.166l14.67,57.86h16.72l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40985",
    "data-name": "Path 40985",
    className: "cls-6",
    d: "M287.856,259.166l14.67,57.86h16.72l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40986",
    "data-name": "Path 40986",
    className: "cls-7",
    d: "M321.286,259.166l14.68,57.86h16.71L338,259.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40987",
    "data-name": "Path 40987",
    className: "cls-6",
    d: "M321.286,259.166l14.68,57.86h16.71L338,259.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40988",
    "data-name": "Path 40988",
    className: "cls-3",
    d: "M252.346,259.166l14.67,57.86h16.72l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40989",
    "data-name": "Path 40989",
    className: "cls-6",
    d: "M252.346,259.166l14.67,57.86h16.72l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40990",
    "data-name": "Path 40990",
    className: "cls-3",
    d: "M440.576,276.326l-4.36-17.16h-16.71l6.29,24.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40991",
    "data-name": "Path 40991",
    className: "cls-6",
    d: "M440.576,276.326l-4.36-17.16h-16.71l6.29,24.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40992",
    "data-name": "Path 40992",
    className: "cls-3",
    d: "M411.016,291.606l-8.23-32.44h-16.71l10.16,40.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40993",
    "data-name": "Path 40993",
    className: "cls-6",
    d: "M411.016,291.606l-8.23-32.44h-16.71l10.16,40.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40994",
    "data-name": "Path 40994",
    className: "cls-3",
    d: "M218.906,259.166l14.68,57.86h16.72l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40995",
    "data-name": "Path 40995",
    className: "cls-6",
    d: "M218.906,259.166l14.68,57.86h16.72l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40996",
    "data-name": "Path 40996",
    className: "cls-3",
    d: "M381.456,306.9l-12.1-47.73h-16.72l14.05,55.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40997",
    "data-name": "Path 40997",
    className: "cls-6",
    d: "M381.456,306.9l-12.1-47.73h-16.72l14.05,55.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40998",
    "data-name": "Path 40998",
    className: "cls-3",
    d: "M285.776,259.166l14.68,57.86h16.71l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40999",
    "data-name": "Path 40999",
    className: "cls-6",
    d: "M285.776,259.166l14.68,57.86h16.71l-14.68-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41000",
    "data-name": "Path 41000",
    className: "cls-3",
    d: "M319.206,259.166l14.68,57.86H350.6l-14.67-57.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41001",
    "data-name": "Path 41001",
    className: "cls-6",
    d: "M319.206,259.166l14.68,57.86H350.6l-14.67-57.86Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_217",
    "data-name": "Line 217",
    className: "cls-6",
    x2: 238.51,
    transform: "translate(206.636 259.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41002",
    "data-name": "Path 41002",
    className: "cls-3",
    d: "M205.016,248.046h3.76l-4.53-19.23h-46.77l2.91,3.66h40.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41003",
    "data-name": "Path 41003",
    className: "cls-6",
    d: "M205.016,248.046h3.76l-4.53-19.23h-46.77l2.91,3.66h40.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41004",
    "data-name": "Path 41004",
    className: "cls-3",
    d: "M84.986,374.816l46.29-20.37v16.69l-46.29,14.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41005",
    "data-name": "Path 41005",
    className: "cls-6",
    d: "M84.986,374.816l46.29-20.37v16.69l-46.29,14.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41006",
    "data-name": "Path 41006",
    className: "cls-7",
    d: "M165.806,332.686a50.23,50.23,0,1,1-50.23,50.23,50.23,50.23,0,0,1,50.23-50.23"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1272",
    "data-name": "Ellipse 1272",
    className: "cls-6",
    cx: 50.23,
    cy: 50.23,
    r: 50.23,
    transform: "translate(115.576 332.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41007",
    "data-name": "Path 41007",
    className: "cls-3",
    d: "M148.348,365.456a24.69,24.69,0,1,1,0,34.917,24.691,24.691,0,0,1,0-34.917"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1273",
    "data-name": "Ellipse 1273",
    className: "cls-6",
    cx: 24.69,
    cy: 24.69,
    r: 24.69,
    transform: "translate(141.117 358.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41008",
    "data-name": "Path 41008",
    className: "cls-3",
    d: "M165.806,365.136a17.78,17.78,0,1,1-17.78,17.78,17.78,17.78,0,0,1,17.78-17.78"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1274",
    "data-name": "Ellipse 1274",
    className: "cls-6",
    cx: 17.78,
    cy: 17.78,
    r: 17.78,
    transform: "translate(148.026 365.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41009",
    "data-name": "Path 41009",
    className: "cls-3",
    d: "M221.736,392.576h19.65v-58.95h-19.65Zm17.35-2.48h-15.04v-11.14h15.04Zm0-13.39h-15.04v-12.05h15.04Zm0-14.3h-15.04v-12.05h15.04Zm0-14.3h-15.04v-11.99h15.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41010",
    "data-name": "Path 41010",
    className: "cls-6",
    d: "M221.736,392.576h19.65v-58.95h-19.65Zm17.35-2.48h-15.04v-11.14h15.04Zm0-13.39h-15.04v-12.05h15.04Zm0-14.3h-15.04v-12.05h15.04Zm0-14.3h-15.04v-11.99h15.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41011",
    "data-name": "Path 41011",
    className: "cls-7",
    d: "M344.376,332.686a50.23,50.23,0,1,1-50.23,50.23,50.23,50.23,0,0,1,50.23-50.23"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1275",
    "data-name": "Ellipse 1275",
    className: "cls-6",
    cx: 50.23,
    cy: 50.23,
    r: 50.23,
    transform: "translate(294.146 332.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41012",
    "data-name": "Path 41012",
    className: "cls-3",
    d: "M327.542,364.885A24.69,24.69,0,1,1,326.3,399.78a24.69,24.69,0,0,1,1.237-34.895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41013",
    "data-name": "Path 41013",
    className: "cls-6",
    d: "M327.542,364.885A24.69,24.69,0,1,1,326.3,399.78,24.69,24.69,0,0,1,327.542,364.885Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41014",
    "data-name": "Path 41014",
    className: "cls-3",
    d: "M344.376,365.136a17.78,17.78,0,1,1-17.78,17.78,17.78,17.78,0,0,1,17.78-17.78"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1276",
    "data-name": "Ellipse 1276",
    className: "cls-6",
    cx: 17.78,
    cy: 17.78,
    r: 17.78,
    transform: "translate(326.596 365.136)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7912",
    "data-name": "Rectangle 7912",
    className: "cls-7",
    width: 8.83,
    height: 29.8,
    transform: "translate(152.326 246.296)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7913",
    "data-name": "Rectangle 7913",
    className: "cls-6",
    width: 8.83,
    height: 29.8,
    transform: "translate(152.326 246.296)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandarddisedProjectImg);
export default __webpack_public_path__ + "static/media/standarddised_project_Img.8f9954b65e776d7f91ad8f8da40bfa19.svg";
export { ForwardRef as ReactComponent };